import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router, UrlTree } from '@angular/router';

import { PtAuthSessionService } from '@pt/services/auth';

/** Default landing page for authenticated users trying to open guest-only routes. */
const DEFAULT_AUTHENTICATED_HOME = '/profile';

/** Shared route check for guest-only branches. */
async function requireGuestSession(): Promise<boolean | UrlTree> {
  const platformId = inject(PLATFORM_ID);
  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  const authSession = inject(PtAuthSessionService);
  const router = inject(Router);

  const authenticated = await authSession.initializeSession();
  if (!authenticated) {
    return true;
  }

  return router.createUrlTree([DEFAULT_AUTHENTICATED_HOME]);
}

/**
 * Restricts guest-only routes to unauthenticated sessions.
 */
export const noAuthGuard: CanActivateFn = () => {
  return requireGuestSession();
};

/**
 * Mirrors guest-only checks for nested route activation.
 */
export const noAuthChildGuard: CanActivateChildFn = () => {
  return requireGuestSession();
};
